import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ze9xj3576d: FaireBrandEntity = {
  token: "b_ze9xj3576d",
  type: "brand",
  name: "Indian Creek Threads",
  avatarUrl:
    "https://cdn.faire.com/fastly/f139f1cd35bf9469deb74d4a290a96a214d63744f5c6eb137eb12f8f2640ae44.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a9104d0f3987b805da81dd7ee4a6d11d58f1fba06b59a9eea4aa23f0143e633.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f139f1cd35bf9469deb74d4a290a96a214d63744f5c6eb137eb12f8f2640ae44.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a9104d0f3987b805da81dd7ee4a6d11d58f1fba06b59a9eea4aa23f0143e633.png",
  location: "West Plains, MO, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "The ICT Story: Built for Boys, Born from Purpose\nICT was born out of one mom’s frustration—and a whole lot of love.\n\nAfter welcoming my third son, I hit a breaking point. Shopping for boys’ clothes felt like hitting the same wall over and over again: bland colors, boring prints, and zero personality. I knew my boys were bold, adventurous, and full of spirit—so why didn't their clothes reflect that?\n\nThat’s when ICT came to life.\n\nWhat started as a personal mission quickly became a purpose: to design trendy, bold, and unique clothing for boys of all sizes. Whether your son is tearing up the race track, laying low in the hunting blind, or owning the basketball court, we’ve got designs that match his energy and style. ICT is more than just apparel—it’s about giving boys the confidence to express who they are.\n\nWe create graphics that speak their language. Prints that pop. Outfits that keep up. Every piece is thoughtfully designed by a boy mom who gets it—and made for the boys who live out loud.\n\nICT isn’t just a brand. It’s a movement to make boys’ fashion as fun, fearless, and full of life as they are.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:47.071Z",
    importedBy: "entity-db-cli",
  },
};
